var map = {
	"./PlatInfo.vue": "b66e",
	"./PlatMenu.vue": "9e12",
	"./PlatStaff.vue": "c98b",
	"./components/DepMana.vue": "1ebf",
	"./components/PermissMana.vue": "ce18",
	"./components/PosMana.vue": "f079"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "45aa";